// extracted by mini-css-extract-plugin
module.exports = {"header":"_3039uE_G6VhRuV-Cu-eGwS","text":"dJgg9PNwgMdtXUrtb_czW","modal":"_147-j4YP4EpdIh1rkNHy-W","divider":"_2MHBvQAX1QHCWR4STddLJF","confirm-button":"_3QxWvnSl6Uqe8g1w3y8PyK"};